import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import FeatureGrid from "./components/FeatureGrid";
import CategoryGrid from "./components/CategoryGrid";
import DarkFeatureSection from "./components/DarkFeatureSection";
import SEOArticlesGrid from "./components/SEOArticlesGrid";
import CTASection from "./components/CTASection";
import type { CategoryCard } from "@/types";

const grid1Cards: CategoryCard[] = [
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Front%20facing%20product%20shot%20of%20a%20premium%20olive%20green%20bomber%20jacket%20hanging%20on%20a%20wooden%20hanger%20against%20a%20warm%20terracotta%20wall%2C%20dramatic%20side%20lighting%20with%20deep%20shadows%2C%20editorial%20fashion%20photography%2C%20rich%20earthy%20tones%2C%20sophisticated%20minimalist%20composition&width=500&height=420&seq=cat-jackets-v2&orientation=landscape",
    bgClass: "bg-accent-100",
    labelBgClass: "bg-white",
  },
  {
    name: "Pants / Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Flat%20lay%20of%20tailored%20beige%20linen%20trousers%20and%20denim%20shorts%20arranged%20diagonally%20on%20a%20textured%20concrete%20surface%2C%20morning%20sunlight%20casting%20long%20geometric%20shadows%2C%20high%20contrast%20editorial%20composition%2C%20warm%20neutral%20tones%2C%20fashion%20catalog%20style&width=500&height=420&seq=cat-pants-v2&orientation=landscape",
    bgClass: "bg-secondary-100",
    labelBgClass: "bg-white",
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Three%20stylish%20caps%20and%20a%20wide%20brim%20hat%20arranged%20on%20a%20rustic%20wooden%20shelf%20against%20sage%20green%20painted%20wall%2C%20soft%20afternoon%20sunlight%20streaming%20through%20nearby%20window%2C%20warm%20inviting%20atmosphere%2C%20editorial%20still%20life%20photography%2C%20organic%20textures%20and%20earthy%20palette&width=500&height=420&seq=cat-headwear-v2&orientation=landscape",
    bgClass: "bg-background-200",
    labelBgClass: "bg-white",
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Coordinated%20fashion%20set%20of%20a%20matching%20top%20and%20bottom%20in%20soft%20blush%20pink%20tone%20draped%20elegantly%20over%20a%20natural%20rattan%20chair%2C%20bright%20airy%20room%20with%20white%20walls%2C%20soft%20diffused%20daylight%2C%20feminine%20editorial%20aesthetic%2C%20delicate%20and%20sophisticated%20composition&width=500&height=420&seq=cat-sets-v2&orientation=landscape",
    bgClass: "bg-primary-100",
    labelBgClass: "bg-white",
  },
];

const grid2Cards: CategoryCard[] = [
  {
    name: "Underwear / Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Neatly%20folded%20organic%20cotton%20underwear%20basics%20in%20muted%20earth%20tones%20stacked%20on%20a%20clean%20marble%20surface%2C%20soft%20diffused%20studio%20light%20from%20above%2C%20minimal%20composition%20with%20negative%20space%2C%20contemporary%20clean%20aesthetic%2C%20premium%20product%20photography&width=500&height=420&seq=cat-underwear-v2&orientation=landscape",
    bgClass: "bg-accent-100",
    labelBgClass: "bg-white",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Dynamic%20action%20shot%20of%20a%20professional%20sports%20jersey%20in%20bold%20crimson%20red%20laid%20flat%20on%20dark%20slate%20surface%2C%20dramatic%20top%20down%20lighting%20creating%20strong%20contrast%2C%20athletic%20editorial%20photography%2C%20energetic%20composition%20with%20sporty%20aesthetic&width=500&height=420&seq=cat-jersey-v2&orientation=landscape",
    bgClass: "bg-secondary-100",
    labelBgClass: "bg-white",
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Curated%20collection%20of%20fashion%20accessories%20including%20watches%20bracelets%20and%20sunglasses%20scattered%20artfully%20across%20a%20warm%20cognac%20leather%20desk%20mat%2C%20golden%20hour%20light%2C%20luxurious%20editorial%20still%20life%2C%20rich%20amber%20and%20bronze%20tones%2C%20sophisticated%20composition&width=500&height=420&seq=cat-accessories-v2&orientation=landscape",
    bgClass: "bg-background-200",
    labelBgClass: "bg-white",
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20leather%20crossbody%20bag%20and%20canvas%20tote%20bag%20standing%20upright%20on%20a%20light%20oak%20parquet%20floor%20against%20a%20white%20wall%2C%20natural%20daylight%20from%20large%20windows%2C%20clean%20architectural%20composition%2C%20high%20end%20editorial%20product%20photography%2C%20minimalist%20luxury%20aesthetic&width=500&height=420&seq=cat-bags-v2&orientation=landscape",
    bgClass: "bg-primary-100",
    labelBgClass: "bg-white",
  },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "ItaobuySpreadsheet",
              "url": "https://itaobuy.cfd/",
              "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg",
              "description": "The smartest China product sourcing spreadsheet tool for eCommerce sellers and dropshippers. Structured product data, supplier insights, and market trend analysis.",
              "sameAs": ["https://kaspreadsheet.com"]
            })
          }}
        />
        <HeroSection />
        <FeatureGrid />
        <CategoryGrid
          subtitle="Curated Product List"
          titleLine1="Jackets & Pants"
          titleLine2="Sets & Headwear"
          cards={grid1Cards}
        />
        <CategoryGrid
          subtitle="More Categories"
          titleLine1="Accessories & Bags"
          titleLine2="Underwear & More"
          cards={grid2Cards}
        />
        <DarkFeatureSection />
        <SEOArticlesGrid />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}